export default class Template9 {
  static getData() {
    return [];
  }
}
